import React, { useState } from "react";
import BillerDetail from "./BillerDetails/BillerDetail";
import CategoryDetail from "./CategoryDetail/CategoryDetail";

const AgentDetails = () => {
  const [activeComponent, setActiveComponent] = useState("BillerDetail"); // <--- updated

  return (
    <div>
      {/* Navigation buttons */}
      <div style={{ marginBottom: "20px", display: "flex", gap: "3px" }}>
        <h6
          onClick={() => setActiveComponent("BillerDetail")}
          style={{
            padding: "8px 16px",
            fontSize: "14px",
            fontWeight: "lighter",
            color: activeComponent === "BillerDetail" ? "blue" : "black",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Billers Detail
        </h6>
        <h6
          onClick={() => setActiveComponent("CategoryDetail")}
          style={{
            padding: "8px 16px",
            fontSize: "14px",
            fontWeight: "lighter",
            color: activeComponent === "CategoryDetail" ? "blue" : "black",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Categories Detail
        </h6>
      </div>

      {/* Conditional rendering of components */}
      {activeComponent === "BillerDetail" && <BillerDetail />}
      {activeComponent === "CategoryDetail" && <CategoryDetail />}
    </div>
  );
};

export default AgentDetails;
